module.exports = __webpack_public_path__ + "img/home-form-house.71ce9b2b.png";